<template>
  <section class="account">
    <strong>{{ $t("helpers.chat.permissions_error") }}</strong>
    <span>{{ $t("helpers.chat.permissions_message") }}</span>
    <span>{{ $t("helpers.chat.error_permissions_message") }}</span>
    <FAQ />

    <strong>{{ $t("helpers.chat.my_account_error") }}</strong>
    <span>{{ $t("helpers.chat.my_account_message") }}</span>

    <section class="footer">
      <Back @changeComponent="setComponent" />
      <Contact @changeComponent="setComponent" />
    </section>
  </section>
</template>

<script>
import FAQ from "./Faq.vue";
import Back from "./Back.vue";
import Contact from "./Contact.vue";

export default {
  name: "AccountDoubtComponent",

  components: {
    FAQ,
    Back,
    Contact,
  },

  methods: {
    setComponent(component) {
      this.$emit("changeComponent", component);
    },
  },
};
</script>

<style lang="scss" scoped>
.account {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;

  strong {
    font-weight: 600;
  }

  .footer {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
  }
}
</style>
